import { Route, RouteConfig } from 'vue-router';
import { PagePermissionEnum } from '@/types/enum/PermissionEnum';

const dataLineRoute = [
	{
		path: '/projet/:projectToken/dl/facturations',
		name: 'facturations',
		props: true,
		component: () => import(
			/* webpackChunkName: "dataLines" */
			'../../views/DataLines.vue'
		),
		meta: {
			can: (to: Route, from: Route, can: any) => {
				return (can(PagePermissionEnum.DATA_LINES_LIST, {
					token: to.params.projectToken,
					type: 'Project'
				}));
			},
			navigationConfigurationName: 'list-data-line',
			isConfigurationMandatory: true,
			params: {
				type: 'project'
			}
		}
	},
	{
		path: '/projet/:projectToken/dl/facturations/en-cours',
		name: 'billingDataLinesCurrent',
		props: true,
		component: () => import(
			/* webpackChunkName: "dataLines" */
			'../../views/DataLines.vue'
		),
		meta: {
			can: (to: Route, from: Route, can: any) => {
				return (can(PagePermissionEnum.DATA_LINES_LIST, {
					token: to.params.projectToken,
					type: 'Project'
				}));
			},
			navigationConfigurationName: 'billing-list-data-line-current',
			isConfigurationMandatory: true,
			params: {
				type: 'billing-current'
			}
		}
	},
	{
		path: '/projet/:projectToken/dl/facturations/passes',
		name: 'billingDataLinesPast',
		props: true,
		component: () => import(
			/* webpackChunkName: "dataLines" */
			'../../views/DataLines.vue'
		),
		meta: {
			can: (to: Route, from: Route, can: any) => {
				return (can(PagePermissionEnum.DATA_LINES_LIST, {
					token: to.params.projectToken,
					type: 'Project'
				}));
			},
			navigationConfigurationName: 'billing-list-data-line-past',
			isConfigurationMandatory: true,
			params: {
				type: 'billing-past'
			}
		}
	}
] as RouteConfig[];

export default dataLineRoute;
